import React, {useContext, useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
import {Button, InputGroup, Stack} from "react-bootstrap";
import AppContext from "../contexts/app-context";
import * as backendUtils from "../helper/BackendUtils";
import {getErrorMessage} from "../helper/BackendUtils";
import './JoinEvent.css';
import {moreThanXDaysDifference} from "../helper/DateUtils";


const JoinEvent = ({event, email, participant, handleJoinEvent}) => {
    const context = useContext(AppContext);
    const [valid, setValid] = useState(false);

    const [distance, setDistance] = useState(0);

    useEffect(() => {
        const validateForm = () => {
            setValid((isSexValid() && isStravaIdValid() && isDistanceValid()))
        }
        validateForm()
    }, [participant, distance])

    const isSexValid = () => {
        return !requiresSex() || (participant?.sex === "M" || participant?.sex === "F");
    }

    const isStravaIdValid = () => {
        return !requiresStravaId() || participant?.stravaId !== "";
    }

    const isDistanceValid = () => {
        return !requiresDistance() || distance > 0;
    }

    const requiresStravaId = () => {
        return event.type === "sum-commute" || event.type === "sum-total";
    }

    const requiresSex = () => {
        return event.type === "sum-commute" || event.type === "sum-total";
    }

    const requiresDistance = () => {
        return event.type === "counter-commute";
    }

    const prepareData = () => {
        return {
            "stravaId": participant?.stravaId,
            "sex": participant?.sex === "T" ? "" : participant?.sex,
            "category": distance ? distance : null
        };
    }

    const joinEvent = () => {
        console.log(`Handle join an event ${event.name}`)

        backendUtils.postRequest(`${context.backendUri}/event/${event.id}/${email}`, {}, prepareData(), () => {
        }, err => {
            console.log(getErrorMessage(err))
        }).then(() => handleJoinEvent())
    }

    const toEarlyToJoin = (startDate) => {
        return moreThanXDaysDifference(new Date(), new Date(startDate), 7);
    }

    return (
        <Stack className="join-element" direction="horizontal" gap={2}>
            <InputGroup size="sm" hidden={!requiresStravaId()}>
                <InputGroup.Text>Strava id</InputGroup.Text>
                <Form.Control value={participant?.stravaId} disabled
                              placeholder={"Requires strava athlete id"} isInvalid={participant?.stravaId === ""}
                              isValid={participant?.stravaId !== ""}/>
            </InputGroup>
            <InputGroup size="sm" hidden={!requiresSex()}>
                <InputGroup.Text>Category</InputGroup.Text>
                <Form.Control value={participant?.sex === 'M' ? "Men" : (participant?.sex === 'F' ? "Women" : "")}
                              disabled
                              placeholder={"Requires category"}
                              isInvalid={!isSexValid()}
                              isValid={isSexValid()}/>
            </InputGroup>
            <InputGroup size="sm" hidden={!requiresDistance()}>
                <InputGroup.Text>Distance</InputGroup.Text>
                <Form.Select onChange={e => setDistance(e.target.value)} value={distance}
                             isInvalid={distance === 0} isValid={distance > 0}>
                    <option value={0}>Declare distance (one way)</option>
                    <option value={1}>STREET: up to 2km</option>
                    <option value={2}>ESTATE: 2km - 4.5km</option>
                    <option value={3}>DISTRICT: 4.5km - 9.5km</option>
                    <option value={4}>CITY: 9.5km - 12.5km</option>
                    <option value={5}>SUBURB: over 12.5 km</option>
                </Form.Select>
            </InputGroup>
            <Button onClick={joinEvent} variant="success" disabled={!valid || toEarlyToJoin(event.startDate)}>Join!</Button>
        </Stack>
    )
}

export default JoinEvent;